import styled from '@emotion/styled';
import { Element } from 'react-scroll';

import BaseLink from '@/components/common/BaseLink/BaseLink';
import { screen } from '@/components/common/breakpoints';

export interface PostTableOfContentsListItemProps {
  handleSetActiveItem: (item: string) => void;
  headingKey: string;
  headingId: string;
  headingString: string;
  isActive: boolean;
}

export const PostTableOfContentsListItem = ({
  handleSetActiveItem,
  headingKey,
  headingId,
  headingString,
  isActive,
}: PostTableOfContentsListItemProps) => {
  return (
    <li key={`${headingKey}-${headingId}`}>
      <PostToClick
        to={headingId}
        offset={-120}
        duration={350}
        delay={25}
        spyThrottle={1}
        spy
        smooth
        onSetActive={handleSetActiveItem}
        className={`${isActive ? 'active' : ''} blog-post-toc-item`}
      >
        <BaseLink href={`#${headingId}`} iconPosition="left">
          {headingString}
        </BaseLink>
      </PostToClick>
    </li>
  );
};

const PostToClick = styled(Element)`
  :visited {
    color: inherit;
  }

  ${screen.md} {
    &.active {
      color: var(--text-inverse-strong);
      background: var(--surface-primary);
    }
  }
`;
